import { inject, isDevMode } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { TranslationService } from '@services/translation/translation.service';

export const DevEnvGuard: CanActivateFn = (): boolean => {
  const translation_svc: TranslationService = inject(TranslationService);

  translation_svc.setTranslations(undefined);
  return isDevMode();
};
